export enum ETypePrelevementAir {
    CO = 1,
    CO2 = 2,
    O2 = 3,
    BrouillardHuile = 4,
    TemperatureRosee = 5,
}